<template>
	<div class="container">
		<div class="servers">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="基本信息" class="form_title"> </el-form-item>
				<el-form-item label="云厂商">
					<el-radio-group v-model="form.cloud" @change="reqregions">
						<el-radio :label="2" border>
							<img src="@/assets/images/tenxun.png" class="servers_icon" />腾讯云
						</el-radio>
						<el-radio :label="1" border>
							<img src="@/assets/images/ol.png" class="servers_icon" />阿里云
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="付费方式">
					<el-radio-group v-model="form.rates" @change="payment">
						<el-radio label="month" border> 包月 </el-radio>
						<el-radio label="year" border> 包年 </el-radio>
						<!-- <el-radio label="hour" border> 按时（测试） </el-radio> -->
					</el-radio-group>
				</el-form-item>
				<el-form-item label="区域">
					<el-radio-group v-model="form.area" class="servers_area" @change="reqspecification">
						<el-radio v-for="item in form.areaList" :key="item.id" :label="item.id" border>
							{{ item.name }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="规格">
					<el-table
						:data="form.specification"
						style="width: 100%"
						:header-cell-style="{ background: '#eef1f6' }"
						height="500"
					>
						<el-table-column align="center" width="80">
							<template slot-scope="scope">
								<el-radio
									class="radio"
									v-model="scope.row.radio"
									:label="true"
									@change="specificationChange(scope.row)"
									>{{ '' }}</el-radio
								>
							</template>
						</el-table-column>
						<el-table-column prop="kind" label="类型"> </el-table-column>
						<el-table-column prop="name" label="规格"> </el-table-column>
						<el-table-column label="vCPU">
							<template slot-scope="scope">
								<div>{{ scope.row.cpu }} CPU</div>
							</template>
						</el-table-column>
						<el-table-column label="内存">
							<template slot-scope="scope">
								<div>{{ scope.row.memory }} GB</div>
							</template>
						</el-table-column>
						<!-- <el-table-column prop="address" label="内网宽带"> </el-table-column>
						<el-table-column prop="address" label="备注"> </el-table-column>
						<el-table-column prop="address" label="参考价格"> </el-table-column> -->
					</el-table>
				</el-form-item>
				<el-form-item label="已选规格">
					<div>
						{{ form.selectedSpecification.name }} ({{ form.selectedSpecification.kind }}，
						{{ form.selectedSpecification.cpu }}CPU {{ form.selectedSpecification.memory }}GB)
					</div>
				</el-form-item>
				<el-form-item label="镜像">
					<el-select v-model="form.mirrored" @change="changeMirrored" placeholder="请选择" style="width: 40%">
						<el-option
							v-for="item in form.mirroredOptions"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="带宽">
					<el-select v-model="form.bandwidth" placeholder="请选择" @change="PriceList">
						<el-option
							v-for="item in form.bandwidthoptions"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="购买数量">
					<div class="servers_num">
						<el-slider
							v-model="form.num"
							:min="1"
							:max="50"
							style="width: 200px; margin-right: 20px"
							:show-tooltip="false"
							@change="PriceList"
						></el-slider>
						<el-input-number
							@change="PriceList"
							v-model="form.num"
							controls-position="right"
							:min="1"
							:max="50"
							:step="1"
							:precision="0"
						></el-input-number>
					</div>
					<div class="servers_hint">一次最少添加1台,最大50台</div>
				</el-form-item>
				<el-form-item label="购买时长" v-if="buyTime">
					<el-select v-model="form.time" placeholder="请选择" @change="PriceList">
						<el-option v-for="item in form.options" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="servers_footer">
			<div>
				配置费用：<span class="servers_cost">￥{{ configurationCost }}</span>
			</div>
			<div>
				<el-button
					size="small "
					type="primary"
					style="background: rgb(230, 151, 82); border: none; color: white"
					@click="reqliteEcs"
					>点击购买
				</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { regions, specification, Price, liteEcs, ecsImage } from '@/utils/api'
export default {
	data() {
		return {
			form: {
				cloud: 2, //云厂商
				rates: 'month', //收费标准
				area: 0, //区域
				areaList: [],
				specification: [], //规格
				selectedSpecification: {
					id: '',
					name: '',
					kind: '',
					cpu: '',
					memory: '',
				}, //已选规格
				mirrored: '', //镜像
				mirroredOptions: [], //镜像列表
				bandwidth: 1, //带宽
				bandwidthoptions: [
					{ id: 1, name: '1M' },
					{ id: 2, name: '2M' },
					{ id: 3, name: '3M' },
					{ id: 4, name: '4M' },
					{ id: 5, name: '5M' },
				],
				password: '', //初始密码
				num: 1, //购买数量
				time: 1, //购买时长
				options: [
					{ id: 1, name: '1个月' },
					{ id: 2, name: '2个月' },
					{ id: 3, name: '3个月' },
					{ id: 6, name: '6个月' },
				],
			},
			month: [
				{ id: 1, name: '1个月' },
				{ id: 2, name: '2个月' },
				{ id: 3, name: '3个月' },
				{ id: 6, name: '6个月' },
			],
			year: [
				{ id: 1, name: '1年' },
				{ id: 2, name: '2年' },
				{ id: 3, name: '3年' },
			],
			buyTime: true,
			priceList: {}, //价格列表
			configurationCost: 0, //配置费用
		}
	},
	mounted() {
		this.reqregions()
	},
	methods: {
		//价格列表
		PriceList() {
			let params = {
				regionID: this.form.area,
				payMethod: this.form.rates,
				payPeriod: this.form.time,
				replicas: this.form.num,
				sizeID: this.form.selectedSpecification.id,
				imageID: this.form.mirrored,
				internetBandwidth: this.form.bandwidth,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				cloud: this.form.cloud,
			}
			Price(params).then((res) => {
				this.configurationCost = res.discountPrice
			})
		},
		//区域选择
		reqregions() {
			let params = {
				cloud: this.form.cloud,
			}
			regions(params).then((res) => {
				this.form.areaList = res.items
				this.form.area = res.items[0].id
				//规格
				this.reqspecification()
			})
		},
		//付费方式
		payment(val) {
			if (val === 'month') {
				this.buyTime = true
				this.form.options = this.month
			} else if (val === 'year') {
				this.buyTime = true
				this.form.options = this.year
			} else {
				this.buyTime = false
			}
			this.form.time = 1
			this.PriceList()
		},
		//规格列表
		reqspecification() {
			let params = {
				cloud: this.form.cloud,
				type: 'host',
				regionID: this.form.area,
			}
			specification(params).then((res) => {
				res.forEach((item, index) => {
					index === 0 ? (item.radio = true) : (item.radio = false)
				})
				this.form.selectedSpecification = res[0]
				this.form.specification = res
				this.mirrored()
			})
		},
		//规格选择
		specificationChange(row) {
			this.form.selectedSpecification = row
			this.form.specification.forEach((item) => {
				if (item.id !== row.id) {
					item.radio = false
				}
			})
			this.mirrored()
		},
		//镜像列表
		mirrored() {
			let params = {
				ecsId: this.form.selectedSpecification.id,
				zoneId: this.form.selectedSpecification.zone_id,
			}
			ecsImage(params).then((res) => {
				this.form.mirroredOptions = res
				this.form.mirrored = res[0].id
				this.PriceList()
			})
		},
		//镜像切换
		changeMirrored() {
			this.PriceList()
		},
		//创建云主机
		reqliteEcs() {
			let params = {
				regionID: this.form.area,
				payMethod: this.form.rates,
				payPeriod: this.form.time,
				replicas: this.form.num,
				sizeID: this.form.selectedSpecification.id,
				imageID: this.form.mirrored,
				internetBandwidth: this.form.bandwidth,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				cloud: this.form.cloud,
				kind: this.form.selectedSpecification.kind,
			}

			liteEcs(params).then((res) => {
				this.$router.push({
					path: '/pay',
					query: {
						orderNo: res.orderNo,
						moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
					},
				})
			})
		},
	},
}
</script>
<style scoped>
.container {
	padding: 0 10%;
}

.servers {
	padding-top: 28px;
	padding-bottom: 80px;
}
.servers_footer {
	position: absolute;
	left: 150px;
	bottom: 0;
	right: 0;
	height: 50px;
	line-height: 50px;
	border-top: 1px solid #ccc;
	background-color: #fff;
	padding: 0 10%;
	box-sizing: border-box;
	font-size: 14px;
	color: #ccc;
	display: flex;
	justify-content: space-between;
	z-index: 80;
}
.servers_area >>> .el-slider__button-wrapper {
	z-index: 70;
}
.servers_cost {
	font-size: 16px;
	color: #e69752;
}
.servers_num {
	display: flex;
	justify-content: start;
}
.servers_hint {
	font-size: 12px;
	color: #ccc;
}
.servers_area >>> .el-radio {
	margin-bottom: 10px;
}
.servers_icon {
	width: 28px;
	vertical-align: middle;
	margin-right: 10px;
	padding-bottom: 3px;
}
.form_title {
	font-weight: bold !important;
}
.form_title >>> .el-form-item__label {
	font-size: 16px !important;
}
.servers >>> .el-form-item__label {
	text-align: left !important;
}
.servers >>> .el-radio__input {
	display: none;
}
.servers >>> .el-radio.is-bordered {
	background-color: #fff;
	padding: 0px 20px 0 10px;
	line-height: 40px;
	text-align: center;
	width: 120px;
}
.servers >>> .el-radio.is-bordered.is-checked {
	background-color: #f1f4f8;
}
.servers >>> .el-radio.is-bordered + .el-radio.is-bordered {
	margin-left: 0px;
}
.servers >>> .el-table td {
	padding: 10px 0;
}
.servers >>> .el-table th {
	padding: 0;
}
.radio >>> .el-radio__input {
	display: inline;
}
</style>
